import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchPriceLabels } from 'utils/api/priceLableApi'
import { columns } from './utils'

interface PriceLabelDataTableProps {
  isEditor: boolean
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const PriceLabelDataTable = ({
  loading,
  setLoading,
}: PriceLabelDataTableProps) => {
  const [priceLabelResponse, setPriceLabelResponse] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getPriceLabelData = async () => {
    setLoading(true)
    const { limit, page, search, priceLabelFilters } = getAllQueries()
    try {
      const { data } = await fetchPriceLabels({
        limit: limit || 10,
        page: page || 1,
        search: search,
        filters: priceLabelFilters,
      })

      setPriceLabelResponse({ ...data })
    } catch (error) {
      setPriceLabelResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPriceLabelData()
  }, [search])

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : priceLabelResponse.docs}
        identifier="_id"
        activeColumns={priceLabelResponse?.tableConfig?.priceLabel || []}
      />

      <DataTablePagination
        currentPage={priceLabelResponse?.page}
        totalPages={priceLabelResponse?.totalPages}
        hasNextPage={priceLabelResponse?.hasNextPage}
        hasPrevPage={priceLabelResponse?.hasPrevPage}
        limit={priceLabelResponse?.limit}
        nextPage={priceLabelResponse?.nextPage}
        prevPage={priceLabelResponse?.prevPage}
        disabled={loading}
        shouldDisplayTotalPages={false}
        disableGoToLastPage
      />
    </>
  )
}

export default PriceLabelDataTable
